import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PublicRoutes } from "./public-routes";
import { PrivateRoutes } from "./private-routes";
import LoginPage from "src/pages/public/login";
import ForgotPasswordPage from "src/pages/public/forgot-password";
import { Layout } from "src/shared/layout";
import { doc, getDoc } from "firebase/firestore";
import { authentication, db } from "src/firebase";
import { useRecoilState } from "recoil";
import { authState } from "src/store/auth";
import { IUserPermissions } from "src/types/generic";
import { LinearProgress } from "@mui/material";
import { signOut } from "firebase/auth";
import { notificationsState } from "src/store/notifications";
import ReportsSalesSummaryPage from "src/pages/private/reports/sales-summary";
import ClientProfilePage from "src/pages/private/client-profile";
import TicketsValidationPage from "src/pages/private/tickets-validations";
import GolfCartRequestsPage from "src/pages/private/golf-requests";
import AddEditGolfRequestPage from "src/pages/private/golf-requests/request-form";

function AllRoutes() {
  const [auth, setAuth] = useRecoilState(authState);
  const [permissions, setPermissions] = useState<IUserPermissions>();
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  const hasAtLeastOneDashPerm: boolean = Object.values(
    permissions?.client_dashboard ?? []
  ).some((v) => v === true);

  useEffect(() => {
    const fetchUserPermissions = async () => {
      if (auth.user) {
        try {
          setLoading(true);
          const docRef = doc(db, "users", auth.user.uid);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            // if no permissions sign user out
            if (!docSnap.data().permissions) {
              signOut(authentication)
                .then(() => {
                  // Sign-out successful.
                  setNotifications([
                    ...notifications,
                    {
                      type: "error",
                      message: "You have no permissions",
                    },
                  ]);
                  localStorage.clear();
                  window.location.reload();
                })
                .catch((error) => {
                  console.log(error);
                });
              return;
            }
            console.log("client per", docSnap.data().permissions);
            setPermissions(docSnap.data().permissions);
            setAuth({
              ...auth,
              permissions: docSnap.data().permissions,
              user: {
                ...auth.user,
                clientJoiningDate: docSnap.data().clientJoiningDate,
              },
            });
          } else {
            console.log("No such user!");
            signOut(authentication)
              .then(() => {
                // Sign-out successful.
                localStorage.clear();
                window.location.reload();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } catch (error: any) {
          console.error("Error fetching user data:", { error });
          if (error.code === "permission-denied") {
            signOut(authentication)
              .then(() => {
                // Sign-out successful.
                localStorage.clear();
                window.location.reload();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserPermissions();
  }, []);

  return loading || (!!auth.user && !auth.permissions) ? ( //loading || (!!auth.user && !auth.permissions)
    <LinearProgress />
  ) : (
    <BrowserRouter>
      <Routes>
        <Route
          element={
            <PublicRoutes
              firstRouteToAccess={
                hasAtLeastOneDashPerm ? "reports/sales" : "tickets-validation"
              }
            />
          }
        >
          <Route element={<LoginPage />} path="/login" />
          <Route element={<LoginPage />} path="/" />
          <Route element={<ForgotPasswordPage />} path="/forgot-password" />
        </Route>
        <Route element={<PrivateRoutes />}>
          <Route element={<Layout />}>
            {/* Reports */}
            <Route
              element={<ReportsSalesSummaryPage />}
              path="/reports/sales"
            />
            {/* Tickets validation */}
            <Route
              element={<TicketsValidationPage />}
              path="/tickets-validation"
            />
            {/* golf requests */}
            <Route
              element={<GolfCartRequestsPage />}
              path="/golf-requests"
            />
            <Route
              element={<AddEditGolfRequestPage />}
              path="/golf-requests/add"
            />
            <Route
              element={<AddEditGolfRequestPage />}
              path="/golf-requests/:id"
            />
            {/* profile */}
            <Route element={<ClientProfilePage />} path="profile" />
            <Route element={<ClientProfilePage />} path="profile/contacts" />
            <Route element={<ClientProfilePage />} path="profile/accounts" />
            <Route element={<ClientProfilePage />} path="profile/locations" />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AllRoutes;
